// Imports
import { kebabCase } from 'lodash'
import { getAuth, onAuthStateChanged } from "firebase/auth"

export function abort (code = 404) {
  return {
    name: 'FourOhFour',
    path: '*',
    component: () => error(code),
  }
}

export function error (code = 404) {
  return import(
    /* webpackChunkName: "error-[request]" */
    `@/views/${code}.vue`
  )
}

export function layout (layout = 'Default', children, path = '') {
  const dir = kebabCase(layout)

  return {
    children,
    component: () => import(
      /* webpackChunkName: "layout-[request]" */
      `@/layouts/${dir}/Index`
      ),

    beforeEnter: (to, from, next) => {
      const auth = getAuth()
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        unsubscribe()
        if (user) {
          next()
        } else {
          next('/')
        }
      })
    },
    path,
  }
}

export function route (name, component, path = '') {
  component = Object(component) === component
    ? component
    : { default: name.replace(' ', '') }
  const components = {}
  for (const [key, value] of Object.entries(component)) {
    components[key] = () => import(
      `@/views/${value}`
    )
  }
  return {
    name,
    components,
    path,
  }
}
